import { handleActions, Reducer } from "redux-actions";
import {  
    ACTION_CHANGE_COLLAPSED,
    ACTION_CHANGE_REMEMBER,
} from "../actions/style";

export interface styleState {
    collapsed: boolean,
    remember: boolean
}

const defaultState: styleState = {
    collapsed: false,
    remember: true,
}

function handleActionChangeCollapsedSuccess(state: styleState, action: any): styleState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        collapsed: action.payload.collapsed
    };
}


function handleActionChangeRememberSuccess(state: styleState, action: any): styleState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
       remember: action.payload.remember
    };
}

export const styleReducer: Reducer<styleState, any> = handleActions(
    {
        [ACTION_CHANGE_COLLAPSED]: handleActionChangeCollapsedSuccess,
        [ACTION_CHANGE_REMEMBER]: handleActionChangeRememberSuccess,
    },
    defaultState
);
